import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getLenis } from "./SmoothScroll";

/**
 * Resets scroll to top of the page whenever the pathname changes.
 * Works with Lenis smooth scroll and falls back to native window scrolling.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Never reset scroll for in-page hash anchors
    if (hash) return;
    const lenis = getLenis();
    if (lenis) {
      lenis.scrollTo(0, { immediate: true, force: true });
    }
    // Belt-and-suspenders for browsers where lenis hasn't mounted yet
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    if (document.documentElement) document.documentElement.scrollTop = 0;
    if (document.body) document.body.scrollTop = 0;
  }, [pathname, hash]);

  return null;
}
